export function referrerLabel(d) {
    if (!d)
        return 'Unknown referrer';
    if (typeof d === 'string')
        return d;
    return d.firm ? `${d.name}, ${d.firm}` : d.name;
}
export function applicationId(a) {
    return a.applicationId ?? a.id ?? '';
}
